import { render, staticRenderFns } from "./ADescuento.vue?vue&type=template&id=fa4dd1ca&scoped=true"
import script from "./ADescuento.vue?vue&type=script&lang=js"
export * from "./ADescuento.vue?vue&type=script&lang=js"
import style0 from "./ADescuento.vue?vue&type=style&index=0&id=fa4dd1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4dd1ca",
  null
  
)

export default component.exports